module.exports = __webpack_public_path__ + "img/top-3-1.f8811caa.jpg";